// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1TCC-","text":"styles_text__1Lah4","title":"styles_title__1gSH_","description":"styles_description__2pCeN","button":"styles_button__ByadF"};